import React from 'react';
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts';

const data = [
  {name: 'NPS Score', before: 65, after: 85},
];

const NPSBarChart = () => (
  <BarChart
    width={500}
    height={300}
    data={data}
    margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
  >
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="name" />
    <YAxis />
    <Tooltip />
    <Legend />
    <Bar dataKey="before" fill="#8884d8" />
    <Bar dataKey="after" fill="#82ca9d" />
  </BarChart>
);

export default NPSBarChart;